<template>
  <div class="team">
    <div class="team__head">
      <button
        class="icon-button is-filled"
        v-if="! show"
        @click.prevent="toggle"
      >
        <IconSearch/>
      </button>

      <el-input
        v-model="search"
        v-else
        placeholder="Buscar"
      >
        <template #suffix>
          <i
            class="el-input__icon el-icon-close"
            style="cursor: pointer;"
            @click.prevent="toggle"
          />
        </template>
      </el-input>

      <el-button
        type="primary"
        @click="$router.push({ name: 'NewCompany' })"
      >Novo contratante</el-button>
    </div>

    <div class="team__body">
      <div
        class="team__body-empty"
        v-if="companies.length <= 0"
      >
        <span>
          <IconTeam/>
        </span>
        <h3>Ops...</h3>
        <p class="p1">Não há contratantes para carregar.</p>
      </div>

      <div
        class="table"
        v-else
      >
        <el-table
          @row-click="handleClick"
          header-cell-class-name="team__header"
          :data="filtered.slice((page - 1) * 20, page * 20)"
        >
          <el-table-column
            v-for="item in head"
            :key="item.label"
            :prop="item.prop"
            :label="item.label"
            :width="item.width"
            :sortable="item.sortable"
          />
          <el-table-column
            align="left"
            width="56"
          >
            <IconArrow/>
          </el-table-column>

          <template #empty>
            <div class="team__body-empty">
              <span>
                <IconSearch/>
              </span>
              <h3>Nenhum contratante encontrado</h3>
              <p class="p1">Confira a grafia e busque outra vez, ou realize um novo cadastro.</p>
            </div>
          </template>
        </el-table>

        <div
          v-if="companies.length > 20"
          class="team__table-footer"
        >
          <el-pagination
            :page-size="20"
            :current-page="page"
            hide-on-single-page
            :total="companies.length"
            layout="prev, pager, next, jumper"
            @current-change="handlePage"
          />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import companyService from '../../../services/companyService';
import IconTeam from '../../../assets/svgs/icon-team.svg';
import IconArrow from '../../../assets/svgs/icon-arrow-right.svg';
import IconSearch from '../../../assets/svgs/icon-search.svg';

export default {
  components: {
    IconTeam,
    IconArrow,
    IconSearch,
  },

  data: () => ({
    show: false,
    companies: [],
    search: '',
    page: 1,
  }),

  async mounted() {
    this.companies = await companyService.getAll();
    this.companies = this.companies.map((item) => ({ ...item, status: item.status === 'A' ? 'Ativo' : 'Inativo', integrado: (item.integracaoAssinei) ?'Sim':'Não'}));
  },

  computed: {
    head() {
      return [
        {
          prop: 'empresaId',
          label: 'Código',
          width: 119,
          sortable: true,
        },
        {
          prop: 'razaoSocial',
          label: 'Razão Social',
          width: 300,
        },
        {
          prop: 'cnpj',
          label: 'CNPJ',
          width: 220,
        },
        {
          prop: 'segmento',
          label: 'Segmento',
          width: 200,
        },        
        {
          prop: 'integrado',
          label: 'Integrado'          
        },
        {
          prop: 'status',
          label: 'Status',
          sortable: true,
        }
      ];
    },

    filtered() {
      const { companies, search } = this;

      const lowered = search.toLowerCase();

      const items = companies?.filter(({
        razaoSocial, cnpj, segmento,
      }) => (
        (razaoSocial && razaoSocial.toLowerCase().indexOf(lowered) !== -1)
        || (cnpj && cnpj.toLowerCase().indexOf(lowered) !== -1)
        || (segmento && segmento.toLowerCase().indexOf(lowered) !== -1)
      ));

      if (!search) return companies;

      return items;
    },
  },

  methods: {
    toggle() {
      this.show = !this.show;
    },

    handleClick({ empresaId }) {
      this.$router.push({
        params: { empresaId },
        name: 'EditCompany',
      });
    },

    handlePage(page) {
      this.page = page;
    },

    handleGoPage(value) {
      const newPage = Number(value);

      const rest = this.companies.length % 20 === 0 ? 0 : 1;

      const totalPages = Math.trunc(this.companies.length / 20) + rest;

      if (newPage < 1) {
        this.page = 1;

        return;
      }

      if (newPage > totalPages) {
        this.page = totalPages;

        return;
      }

      this.page = newPage;
    },
  },
};
</script>


<style lang="scss">
.team {
  &__head {
    width: fit-content;
    display: flex;
    margin-left: auto;

    button {
      margin-left: 24px;
    }

    .el-input {
      min-width: 316px;
    }
  }

  &__body {
    margin-top: 32px;

    &-empty {
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin: 0 auto;
      text-align: center;
      background-color: $--color-gray-1;
      padding: 64px;
      align-items: center;

      span {
        width: 60px;
        height: 60px;
        display: flex;
        align-items: center;
        border-radius: 50%;
        margin-bottom: 16px;
        justify-content: center;
        background-color: rgba($--color-info, 0.2);

        svg path {
          fill: $--color-info;
        }
      }

      h3 {
        color: $--color-gray-7;
      }

      & p {
        margin-top: 8px;
        color: $--color-gray-6;
        max-width: 272px;
      }
    }
  }

  &__header {
    .cell {
      padding: 0px 0px 0px 10px !important;
    }
  }

  &__table-footer {
    display: flex;
    margin-top: 50px;
    align-items: center;
    justify-content: center;
  }
}

  @media screen and (max-width: 1080px) {
    .team {
      padding: 0px 20px;
      box-sizing: border-box;
    }
  }
</style>
